import React, { useState, useEffect } from "react";
import "./ProjectImage.css";
import Yaaaga from "./images/yag-img.jpg";
import Lynk from "./images/lynk-img.png";
import Ead from "./images/ead-img.png";
import Jazzy from "./images/jazzy-img.png";
import BlurLoader from "../../UI/LazyLoader/BlurLoader";

const ProjectImage = (props) => {
  const [loaded, setloaded] = useState(false);

  const StuffLoaded = () => {
    setTimeout(() => {
      setloaded(true);
    }, 5000);
  };

  let images = {
    yaaaga: Yaaaga,
    lynk: Lynk,
    ead: Ead,
    jazzy: Jazzy,
  };
  const [image, setImage] = useState(Jazzy);

  // eslint-disable-next-line
  useEffect(() => {
    let currentImage = images[props.id];
    setImage(currentImage);
  });

  return (
    <div className="uigrid-5 project-image">
      <div className="project-image-container">
        {!loaded && <BlurLoader />}
        <img src={image} alt="" onLoad={StuffLoaded} />
      </div>
    </div>
  );
};

export default ProjectImage;
